import React from 'react';
import { ProjectRoutes } from '../pages/Routes';

const ProjectContainer = () => {
  return <ProjectRoutes />;
};

export default ProjectContainer;
